import { Outlet } from 'react-router-dom';
import { PlayerNav, HomeIcon, WalletIcon, BettingIcon, HistoryIcon, TrophyIcon } from '../navigation/PlayerNav';
import { useAuth } from '../../contexts/AuthContext';

export function PlayerLayout(): React.ReactElement {
  const { state } = useAuth();

  const navItems = [
    { label: 'Dashboard', to: '/player/dashboard', icon: <HomeIcon /> },
    { label: 'Wallet', to: '/player/wallet', icon: <WalletIcon /> },
    { label: 'Betting', to: '/player/betting', icon: <BettingIcon /> },
    { label: 'History', to: '/player/history', icon: <HistoryIcon /> },
    { label: 'Leaderboard', to: '/player/leaderboard', icon: <TrophyIcon /> },
  ];

  return (
    <div className="min-h-screen bg-background">
      <PlayerNav
        items={navItems}
        playerName={state.user?.display_name || state.user?.username || 'Player'}
      />
      <main className="container mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
